import { useQuery } from '@tanstack/react-query';
import { leaderboardQuery } from '../lib/api.js';
import { cn } from '../lib/cn.js';

/**
 * Career standings, ranked by wins. Only signed-in players accrue stats, so
 * the empty state doubles as the pitch for registering.
 */
export const Leaderboard = () => {
  const board = useQuery(leaderboardQuery);

  if (board.isError) {
    return (
      <p className="py-8 text-center text-sm text-ink-muted">
        The leaderboard is unavailable on this server.
      </p>
    );
  }
  if (!board.data || board.data.length === 0) {
    return (
      <p className="py-8 text-center text-sm text-ink-muted">
        No ranked games yet. Sign in and win a match to claim the top spot.
      </p>
    );
  }

  return (
    <table className="w-full border-separate border-spacing-0 text-sm">
      <thead>
        <tr className="text-[11px] uppercase tracking-[0.2em] text-ink-muted">
          <th className="pb-2 pl-2 text-left font-semibold">#</th>
          <th className="pb-2 text-left font-semibold">Callsign</th>
          <th className="pb-2 text-right font-semibold">Wins</th>
          <th className="pb-2 text-right font-semibold">Kills</th>
          <th className="pb-2 text-right font-semibold">K/D</th>
          <th className="pb-2 pr-2 text-right font-semibold">Games</th>
        </tr>
      </thead>
      <tbody>
        {board.data.map((entry, index) => (
          <tr
            key={entry.name}
            className={cn(
              'text-ink',
              index === 0 && 'text-amber-300',
              index === 1 && 'text-slate-300',
              index === 2 && 'text-orange-300',
            )}
          >
            <td className="rounded-l-md py-1.5 pl-2 tabular-nums text-ink-muted">
              {index + 1}
            </td>
            <td className="py-1.5 font-semibold">{entry.name}</td>
            <td className="py-1.5 text-right tabular-nums">{entry.wins}</td>
            <td className="py-1.5 text-right tabular-nums">{entry.kills}</td>
            <td className="py-1.5 text-right tabular-nums">
              {(entry.kills / Math.max(1, entry.deaths)).toFixed(2)}
            </td>
            <td className="rounded-r-md py-1.5 pr-2 text-right tabular-nums">
              {entry.matchesPlayed}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};
